/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Edit_SavedInputs */

const en_case_edit_saved = /** @type {(inputs: Case_Edit_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case changes saved.`)
};

const pt_br2_case_edit_saved = /** @type {(inputs: Case_Edit_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações do caso salvas.`)
};

/**
* | output |
* | --- |
* | "Case changes saved." |
*
* @param {Case_Edit_SavedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_edit_saved = /** @type {((inputs?: Case_Edit_SavedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Edit_SavedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_edit_saved(inputs)
	return pt_br2_case_edit_saved(inputs)
});